module.exports = __webpack_public_path__ + "img/norway.b21bf1d.webp";